import actions from "./actions";
import mutations from "./mutations";

export const initialState = () => {
  return {
    zoom: 20
  };
};

export const tableViewModule = {
  state: initialState,
  namespaced: true,
  getters: {},
  actions,
  mutations
};
